import {
  ServicesConsents,
  UsercentricsFunctionality,
} from "usercentrics-browser-ui";
import { UsercentricsEvent, UsercentricsServiceName } from "../types/index.js";

export const usercentricsDataProcessingServices = <const>[
  "Promotion",
  "Google Maps",
  "YouTube Video",
];

const getUsercentricsUI = (): Promise<UsercentricsFunctionality> =>
  new Promise(async (resolve) => {
    const initializedEventName = "UC_UI_INITIALIZED";

    const __ucCmp = window.__ucCmp;
    if (await __ucCmp?.isInitialized()) {
      resolve(__ucCmp);
      return;
    }

    const onInitializedEvent = () => {
      window.__ucCmp && resolve(window.__ucCmp);
      window.removeEventListener(initializedEventName, onInitializedEvent);
    };

    window.addEventListener(initializedEventName, onInitializedEvent);
  });

export const getUsercentricsServiceConsents = (
  serviceName: string,
): Promise<ServicesConsents | undefined> =>
  new Promise<ServicesConsents | undefined>(async (resolve) => {
    const __ucCmp = await getUsercentricsUI();
    const consentDetails = (await __ucCmp.getConsentDetails()).services;

    const services = Object.entries(consentDetails).find(
      ([, service]) => service.name === serviceName,
    );

    if (services) {
      const [id, service] = services;
      resolve([{ id, consent: service.consent?.given }]);
    }
    resolve(undefined);
  });

export const getUsercentricsConsent = async (
  serviceName: UsercentricsServiceName,
): Promise<boolean> => {
  if (window.__ucCmp) {
    const consentDetails = await window.__ucCmp.getConsentDetails();

    const service = Object.values(consentDetails.services).find(
      (s) => s.name === serviceName,
    );
    if (!service?.consent) return false;

    return service.consent?.given;
  }
  return false;
};

const checkIsUsercentricsEvent = (event: Event): event is UsercentricsEvent =>
  (<UsercentricsEvent>event)?.detail?.event === "consent_status";

export const onUsercentricsConsent = (
  serviceName: UsercentricsServiceName,
): Promise<void> =>
  new Promise((resolve) => {
    const eventName = "UC_CONSENT";
    const onEvent = (event: Event) => {
      if (checkIsUsercentricsEvent(event) && event.detail[serviceName]) {
        resolve();
        window.removeEventListener(eventName, onEvent);
      }
    };

    window.addEventListener(eventName, onEvent);
  });
